<!-- The local-network-access/local-network/loopback-network tokens are required for Chrome 142+
     Local Network Access (LNA): ainoc-web (CloudFront, public) calls ainoc-api (internal ALB,
     private network), which Chrome blocks in cross-origin iframes unless the embedder explicitly
     delegates the permission here. Removing these tokens silently breaks the dashboard. -->
<iframe
  #aiNocFrame
  allow="fullscreen; local-network-access; local-network; loopback-network"
  class="ai-noc-frame"
  title="AI-NOC Dashboard"
  [src]="aiNocUrl"></iframe>
